import TopLanding from './TopLanding.vue'

export default TopLanding
